module.exports = __webpack_public_path__ + "img/index-banner1.11a1d58a.jpg";